// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { LazyImageStyle } from "@insite/mobius/LazyImage";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { bannerStyles } from "@rpsc/Overrides/Widgets/Basic/Banner";
import { fontConfig } from "@rpsc/XDL/PreStyle/typography";
import { color, xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

bannerStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: ${({ imagePosition }: any) => (imagePosition === "left" ? "row" : "row-reverse")};
        border: 1px solid ${color("common.border")};
        border-radius: 4px;
        overflow: hidden;
        ${xScreen("lte", "md")} {
            flex-direction: column;
        }
    `,
};

bannerStyles.imageWrapperStyles = {
    css: css`
        flex: 1;
        ${LazyImageStyle} {
            display: flex;
            width: 100%;
            ${xScreen("lte", "md")} {
                width: 100%;
            }
            ${xScreen("gt", "md")} {
                &,
                picture {
                    min-height: 283px;
                }
            }
            picture {
                display: flex;
                height: inherit;
                width: inherit;
            }
            img {
                flex: 1;
            }
        }
    `,
};

bannerStyles.textWrapperStyles = {
    css: css`
        flex: 2;
        background-color: ${({ backgroundColor }: any) => backgroundColor || "transparent"};
        padding: 32px;

        ${xScreen("lte", "md")} {
            width: 100%;
            padding: 12px;
        }
    `,
};

bannerStyles.heading = {
    css: css`
        ${TypographyStyle} {
            line-height: 28px;
            font-size: 20px;
            font-weight: ${fontConfig.weight.bold};
        }
    `,
};

bannerStyles.subHeading = {
    css: css`
        ${TypographyStyle} {
            line-height: 26px;
            font-size: 16px;
            font-weight: ${fontConfig.weight.regular};
        }
    `,
};
